import React from 'react';
import { useNavigate } from 'react-router-dom';
import './breadcrumbs.css';

const Breadcrumbs = ({ items = [], sticky = true }) => {
  const navigate = useNavigate();
  const navClassName = sticky ? 'app-breadcrumbs' : 'app-breadcrumbs app-breadcrumbs--inline';

  return (
    <nav className={navClassName} aria-label="Breadcrumb">
      <ol className="app-breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isClickable = Boolean(item.to || item.onClick) && !isLast;
          return (
            <li key={`${item.label}-${item.to || index}`} className="app-breadcrumbs-item">
              {isClickable ? (
                <button
                  type="button"
                  className="app-breadcrumbs-link"
                  onClick={() => {
                    if (item.onClick) {
                      item.onClick();
                      return;
                    }
                    navigate(item.to);
                  }}
                >
                  {item.label}
                </button>
              ) : (
                <span className="app-breadcrumbs-current">{item.label}</span>
              )}
              {!isLast && <span className="app-breadcrumbs-sep" aria-hidden="true">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
